export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14306.f4308428.jpg";